export default {
  Home: 'Maison',
  Work: 'Travailler',
  Other: 'Autre',
  Shipping: 'Expédition',
  'Home Address': 'Adresse du oDmicile',
  'Marketing Address': 'Adresse de Commercialisation',
  'Service Address': 'Adresse de Service',
  'Shipping Address': 'Adresse de Livraison',
  'Work Address': 'Adresse Professionnelle'
};
